<!--  -->
<template>
    <div>
        <div class="dialog">
            <div class="content" :style="{'width':width,'height':height}">
                <div class="header">
                    <span>{{ title }}</span>
                    <i class="el-icon-close" @click="close"></i>
                </div>
                <div class="body">
                    <slot></slot>  
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:{
            type:String,
            default:'预警信息'
        },
        width:{
            type:String,
            default:'13.75rem',
        },
        height: {
            tyep:String,
            default:'6.88rem'
        }
    },
    data() {
        return {

        }
    },

    created() {

    },
    methods: {
        close(){
            this.$emit('close',false)
        }

    }
}
</script>
<style lang="scss" scoped>
.dialog {
    position: fixed;
    z-index: 999999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
}
.content{
    border: 0.01rem solid #EFAB44;
    background: #000000;
}
.header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 0.23rem;
    color: #EFAB44;
    height: 0.48rem;
    line-height:0.48rem;
    background: rgba(239,171,68,0.2);
    padding: 0 0.25rem
}
.body{
    padding: 0.26rem;
}
</style>